import { IterationRule, RuleType } from 'schemas/IterationRule.schema.ts';
import { CampaignConfig } from 'schemas/CampaignConfig.schema.ts';

export const buildRulePathParam = (ruleType?: RuleType) => {
  let rulePathParam = '';

  switch (ruleType) {
    case 'F':
      rulePathParam = 'filter-rules';
      break;
    case 'S':
      rulePathParam = 'suppression-rules';
      break;
    case 'R':
      rulePathParam = 'routing-rules';
      break;
    default:
      rulePathParam = 'routing-rules';
  }

  return rulePathParam;
};

export const matchIterationRuleByPriority = (rule: IterationRule, andNumber: number, priority: number, type: string): boolean => rule.Type === type && rule.Priority === priority && rule.AndNumber === andNumber;

export const getIterationRulesFromCampaign = (campaign: CampaignConfig, iterationId: string): IterationRule[] => {
  const existingIterations = campaign.CampaignConfig.Iterations || [];
  const currentIteration = existingIterations.find((campaignIteration) => campaignIteration.ID === iterationId);
  return currentIteration?.IterationRules || [];
};

export const incrementAndClauseName = (currentAndClauseName: string, andClauseNumber: number): string => {
  const match = currentAndClauseName.match(/^(.+)\s-\s(\d+)$/);

  if (match) {
    return `${match[1]} - ${parseInt(match[2], 10) + 1}`;
  }

  return `${currentAndClauseName} - ${andClauseNumber}`;
};
